<template>
    <div class="cookies">
        <section class="section page-wrapper">
            <div class="section__content">
                <h1 class="section__heading">
                    {{ $t('pages.cookies.heading') }}
                </h1>
                <!-- Cookiebot -->
                <div id="cookieDeclarationContent" />
            </div>
            <Contact />
        </section>
    </div>
</template>

<script>
import Contact from '~/components/sections/Contact.vue';

export default {
    components: {
        Contact,
    },
    head() {
        return {
            title: this.$t('pages.cookies.heading'),
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: this.$t('pages.cookies.seo_description'),
                },
            ],
        };
    },
    mounted() {
        this.loadCookiebotDeclaration();
    },
    methods: {
        loadCookiebotDeclaration() {
            const script = document.createElement('script');
            script.id = 'CookieDeclaration';
            script.src = `https://consent.cookiebot.com/${this.$config.cookiebotId}/cd.js`;
            script.type = 'text/javascript';
            script.async = true;

            document.getElementById('cookieDeclarationContent').appendChild(script);
        },
    },
    nuxtI18n: {
        paths: {
            se: '/cookies',
            'fi-sv': '/cookies',
            fi: '/evasteet',
            en: '/cookies',
            de: '/cookies',
            at: '/cookies',
            no: '/cookies',
            dk: '/cookies-dk',
            ch: '/cookies',
            fr: '/cookies',
        },
    },
};
</script>
